export default __webpack_public_path__ + "static/media/i-no-wrap.eb1410ec.svg";